































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditEquipment from "./edit-outairequipment.vue";
import CreateEquipment from "./create-outairequipment.vue";
class PageEquipmentRequest extends PageRequest {
  FilterText: string;
  cId:Number;
  ftId:Number;
  fId:Number;
  wId:Number;
}
class PageCompanyRequest{
  cId:Number;
  WId:Number;
  ftId:Number;
}

@Component({
  components: {EditEquipment,CreateEquipment },
})
export default class Equipments extends AbpBase {
  pagerequest: PageEquipmentRequest = new PageEquipmentRequest();
  publicpagerequest: PageEquipmentRequest = new PageEquipmentRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
    cId:Number;
  get list() {
    return this.$store.state.outair_equipment.list;
  }
  get loading() {
    return this.$store.state.outair_equipment.loading;
  }
  pageChange(page: number) {
    this.$store.commit("outair_equipment/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("outair_equipment/setPageSize", pagesize);
    this.getpage();
  }
  getsearch(){
    this.$store.state.outair_equipment.currentPage=1;
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "outair_equipment/getAll",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.outair_equipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.outair_equipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.outair_equipment.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getwarehouse();
       this.getpage();
  }
  selWarehouse(value:Number){
    this.pagecompanyrequest.WId = value;
    this.getfloor();
    this.getpage();
  }
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    if(value != 0){
      this.getwarehouse();
      this.getpage();
    }
  }
  selFloor(){
    this.getpage();
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
    {
      title: "库房",
      key: "wId",
       render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist); 
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(wId==entry.id){
            wId=entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(fId==entry.id){
            fId=entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
     {
      title: "SN号",
      key: "snid",
    },
    {
      title: "位置名称",
      key: "locationName",
    },
    {
      title: "设备电压",
      key: "electric",
      render: (h, params) => {
        return h("span", params.row.electric+'v');
      },
    },
    // {
    //   title: "湿度",
    //   key: "humi"
    // },
    // {
    //   title: "温度",
    //   key: "temp"
    // },
    // {
    //   title: "PM2.5",
    //   key: "pM25"
    // },
    // {
    //   title: "PM10",
    //   key: "pM10"
    // },
    // {
    //   title: "VOC挥发物",
    //   key: "VOC"
    // },
    // {
    //   title: "风速",
    //   key: "wind_speed"
    // },
    // {
    //   title: "风向",
    //   key: "wind_direction"
    // },
    // {
    //   title: "噪音",
    //   key: "noise"
    // },
    // {
    //   title: "大气压",
    //   key: "pressure"
    // },
    {
      title: "状态",
      key: "status",
      render: (h, params) => {
        let status = params.row.status;
        if (status == 1) {
          status = "启用";
        } else if (status == 0) {
          status = "停用";
        }
        return h("span", status);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("outair_equipment/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "outair_equipment/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll"
    });
   
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
   async getthreshold(){
      //阈值方案
    //filters
    await this.$store.dispatch({
      type: "threshold/getAll",
      data: this.publicpagerequest,
    });
  }
 
 created() {
    this.getuserName();
    if (this.userName !== "admin") {
      this.getfactory();
      this.getwarehouse();
      this.getfloor();
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getpage();
    
  }
}
